import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSparePurchaseOrders, SparePurchaseOrder } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './sparePurchaseOrdersModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SparePurchaseOrder> useData={useSparePurchaseOrders} config={config} />;
};

export default List;
